export function startMatrixRainEffect({ imgPanelEl }) {
  if (!imgPanelEl) return () => {};

  const canvas = imgPanelEl.querySelector('canvas.matrix-canvas[data-kind="matrix-canvas"]');
  if (!canvas) return () => {};

  const ctx = canvas.getContext('2d');
  if (!ctx) return () => {};

  const chars = '01アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン';
  const fontSize = 14;

  let columns = 0;
  let drops = [];

  const resetDrops = () => {
    columns = Math.max(1, Math.floor(canvas.width / fontSize));
    if (drops.length === columns) return;

    if (drops.length < columns) {
      const next = drops.slice();
      while (next.length < columns) next.push(1);
      drops = next;
      return;
    }

    drops = drops.slice(0, columns);
  };

  const resize = () => {
    const w = imgPanelEl.offsetWidth;
    const h = imgPanelEl.offsetHeight;
    canvas.width = Math.max(1, w);
    canvas.height = Math.max(1, h);
    resetDrops();
  };

  resize();

  const intervalId = setInterval(() => {
    ctx.fillStyle = 'rgba(0, 0, 0, 0.02)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = '#00ff00';
    ctx.font = `${fontSize}px monospace`;

    for (let i = 0; i < drops.length; i++) {
      const text = chars[Math.floor(Math.random() * chars.length)];
      ctx.fillText(text, i * fontSize, drops[i] * fontSize);

      if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
        drops[i] = 0;
      }
      drops[i]++;
    }
  }, 50);

  const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(resize) : null;
  if (observer) observer.observe(imgPanelEl);

  window.addEventListener('resize', resize);

  return () => {
    clearInterval(intervalId);
    window.removeEventListener('resize', resize);
    if (observer) observer.disconnect();
  };
}
